import React, { useMemo } from "react";
import { Image } from "../../../client/api";

type EmblemImageProps = {
  image?: Image | null;
  imageUrl?: string | null;
  width: number;
  className?: string;
  alt?: string;
  round?: boolean;
};

const EmblemImage: React.FC<EmblemImageProps> = ({ image, imageUrl, width, className, alt, round }) => {
  const chosenUrl = useMemo(() => {
    if (imageUrl) return imageUrl;
    if (image?.url) return image.url;
    return undefined;
  }, [imageUrl, image]);

  if (!chosenUrl) {
    return <div className={`w-full h-full bg-bg-secondary dark:bg-bg-secondary-dark ${round ? "rounded-full" : ""} ${className ?? ""}`} style={{ width, aspectRatio: 1 }} />;
  }

  return (
    <div 
      className={`flex items-center justify-center bg-transparent ${round ? "rounded-full overflow-hidden" : ""} ${className ?? ""}`} 
      style={{ 
        width, 
        height: width
      }}
    >
      <img
        src={chosenUrl}
        alt={alt ?? "Team emblem"}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
};

export default EmblemImage;






